export default __webpack_public_path__ + "static/media/country search.ffe6982c.jpeg";